module.exports = __webpack_public_path__ + "60496f7089c445520a97deb0a16dbca2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/question-builder.png
// module id = 1585
// module chunks = 0